/* NUYU 7 Oct 2026: cart drawer discount box and gift wrap (replace Debutify's versions).
   Every change goes through Shopify's cart API with the drawer sections, then redraws .drawer__inner
   exactly as Dawn's quantity buttons do, so the Recurpay offer and every other hook survive. */
(function () {
  if (window.__nuyuCartExtras) return;
  window.__nuyuCartExtras = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function post(url, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  function inner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function redraw(state) {
    var s = state && state.sections;
    if (!s) return;
    var drawer = document.querySelector('cart-drawer');
    if (s['cart-drawer']) {
      var html = inner(s['cart-drawer'], '.drawer__inner');
      var target = document.querySelector('#CartDrawer .drawer__inner');
      if (html !== null && target) target.innerHTML = html;
      if (drawer && typeof state.item_count === 'number') drawer.classList.toggle('is-empty', state.item_count === 0);
    }
    if (s['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bh = inner(s['cart-icon-bubble'], '.shopify-section');
      if (bubble && bh !== null) bubble.innerHTML = bh;
    }
    var more = document.querySelector('#CartDrawer .nuyu-more');
    if (more) more.open = true; // keep the panel open after a change made inside it
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
    }
  }

  function currentCodes() {
    return Array.prototype.map.call(document.querySelectorAll('#CartDrawer .nuyu-disc__code'), function (li) {
      return li.getAttribute('data-code');
    });
  }

  function setStatus(text, ok) {
    var st = document.querySelector('#CartDrawer .nuyu-disc__status');
    if (!st) return;
    st.textContent = text;
    st.classList.toggle('is-ok', !!ok);
    st.classList.toggle('is-bad', !ok && !!text);
  }

  function applyCodes(codes, justAdded) {
    var box = document.querySelector('#CartDrawer nuyu-cart-discount');
    if (box) box.classList.add('is-busy');
    return post('/cart/update.js', { discount: codes.join(',') })
      .then(function (state) {
        redraw(state);
        if (justAdded) {
          var found = (state.discount_codes || []).filter(function (d) {
            return d.code.toLowerCase() === justAdded.toLowerCase();
          })[0];
          if (found && found.applicable) setStatus(found.code + ' applied', true);
          else setStatus("That code isn't valid for this cart", false);
        }
      })
      .catch(function () {
        if (box) box.classList.remove('is-busy');
        setStatus('Something went wrong. Please try again.', false);
      });
  }

  document.addEventListener('click', function (e) {
    var apply = e.target.closest('#CartDrawer .nuyu-disc__apply');
    if (apply) {
      e.preventDefault();
      var input = document.querySelector('#CartDrawer .nuyu-disc__input');
      var code = input ? input.value.trim() : '';
      if (!code) { setStatus('Enter a code first', false); return; }
      var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      codes.push(code);
      applyCodes(codes, code);
      return;
    }
    var rm = e.target.closest('#CartDrawer .nuyu-disc__remove');
    if (rm) {
      e.preventDefault();
      var drop = rm.closest('.nuyu-disc__code').getAttribute('data-code');
      applyCodes(currentCodes().filter(function (c) { return c !== drop; }), null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('#CartDrawer .nuyu-disc__input')) {
      e.preventDefault(); // never submit the drawer form (that would go to checkout)
      var b = document.querySelector('#CartDrawer .nuyu-disc__apply');
      if (b) b.click();
    }
  });

  /* gift wrap */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('#CartDrawer .nuyu-gift__check');
    if (!cb) return;
    var gw = cb.closest('nuyu-gift-wrap');
    var vid = parseInt(gw.getAttribute('data-variant'), 10);
    var key = gw.getAttribute('data-key');
    gw.classList.add('is-busy');
    var req = cb.checked
      ? post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] })
      : post('/cart/change.js', { id: key, quantity: 0 });
    req.then(function (res) {
      // /cart/add.js returns the added items plus sections; fetch the cart for the counts
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        cart.sections = res.sections; redraw(cart);
      });
    }).catch(function () { gw.classList.remove('is-busy'); cb.checked = !cb.checked; });
  });

  var msgTimer = null;
  document.addEventListener('input', function (e) {
    if (!(e.target.matches && e.target.matches('#CartDrawer .nuyu-gift__text'))) return;
    var v = e.target.value;
    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Gift wrap': v, gift_message: v } })
      });
    }, 400);
  });
})();
